import { createFileRoute } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { QtiRenderer } from '@/components/qti/QtiRenderer';
import { qtiApi } from '@/lib/http.server';
import { handleServerFnError } from '@/lib/sentry-helpers';
import { standardMiddlewares } from '@/middlewares/standardMiddlewares';
import { assertUserAuthenticated } from '@/middlewares/userAuthMiddleware';

export const Route = createFileRoute('/qti-stimulus-embed/$qtiId')({
  component: RouteComponent,
  // validateSearch: (search: Record<string, unknown>) => {
  //   return {
  //     primary_color: (search.primary_color as string) ?? '',
  //   };
  // },
  loader: async ({ params }) => {
    const { qtiId } = params;
    const qtiStimulus = await fetchQtiStimulus({ data: { qtiId } });
    return { xml: qtiStimulus.rawXml };
  },
});

const fetchQtiStimulus = createServerFn({
  method: 'POST',
})
  .middleware([standardMiddlewares])
  .validator(
    z.object({
      qtiId: z.string(),
    })
  )
  .handler(async ({ context: { cognitoUser }, data: { qtiId } }) => {
    assertUserAuthenticated(cognitoUser);
    try {
      const { data } = await qtiApi.get(`/stimuli/${qtiId}`);
      return data;
    } catch (error) {
      return handleServerFnError(error, {
        service: 'qti-api',
        function: 'fetchQtiStimulus',
        endpoint: `/stimuli/${qtiId}`,
      });
    }
  });

function RouteComponent() {
  const { xml } = Route.useLoaderData();

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <QtiRenderer xml={xml} />
    </div>
  );
}
